import { __read } from "tslib";
var DIRECTIONS = {
    DESC: 'descending',
    ASC: 'ascending',
};
export var extractOrderDirection = function (orderBy) {
    if (typeof orderBy === 'string') {
        return 'ascending';
    }
    if (Array.isArray(orderBy)) {
        var _a = __read(orderBy, 1), firstSettings = _a[0];
        var direction_1 = firstSettings.direction;
        return DIRECTIONS[direction_1];
    }
    var direction = orderBy.direction;
    return DIRECTIONS[direction];
};
